import React, { FC } from 'react';
import AdrSearchResultListItem, { AdrSearchResultProps } from '../Adr';
import  LinearProgress  from '@mui/material/LinearProgress';

const AdrList: FC<{ result: AdrSearchResultProps[] }> = ({ result }) => {
  return (
    <>
      {result.length < 1 && <LinearProgress />}
      {result.map((item,index) => {
        return <AdrSearchResultListItem key={item?.path?.concat(item?.title).concat(index as any)} data={item} />;
      })}
    </>
  );
};

export default AdrList;
